module.exports = __webpack_public_path__ + "static/014.thumb-b6473a9b94f77f34626de3ee367268d3.jpg";